/**
 * 公開向け contact メールアドレス（UI 表示用）
 *
 * 優先順:
 * 1. サーバーが index.html 配信時に注入する window.__PUBLIC_CONTACT_EMAIL__（Cloud Run runtime .env）
 * 2. Vite ビルド時の VITE_PUBLIC_CONTACT_EMAIL（ローカル dev / ビルドフォールバック）
 * 3. 既定値
 */
const DEFAULT_PUBLIC_CONTACT = 'contact@converge-p.co.jp';

export function getPublicContactEmail() {
  if (typeof window !== 'undefined' && window.__PUBLIC_CONTACT_EMAIL__) {
    return window.__PUBLIC_CONTACT_EMAIL__;
  }
  return import.meta.env.VITE_PUBLIC_CONTACT_EMAIL || DEFAULT_PUBLIC_CONTACT;
}
